import React from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import type { BoxProps } from '@mui/material';
import { StatusChip } from '@components/StatusChip';

type StatusItem = {
  label: string;
  value: string;
  chipVariant?: 'status' | 'metadata';
  chipSize?: 'small' | 'medium';
};

type Props = {
  items: StatusItem[];
  sx?: BoxProps['sx'];
  mobileLayout?: 'vertical' | 'horizontal';
};

export const ResponsiveStatusDisplay: React.FC<Props> = ({
  items,
  sx = {},
  mobileLayout = 'vertical'
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (isMobile) {
    return (
      <Box sx={{ ...sx }}>
        {items.map((item, index) => (
          <Box
            key={index}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              mb: index < items.length - 1 ? 1 : 0,
              flexWrap: mobileLayout === 'horizontal' ? 'nowrap' : 'wrap'
            }}
          >
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ minWidth: 'fit-content' }}
            >
              {item.label}:
            </Typography>
            <StatusChip
              label={item.value}
              variant={item.chipVariant || 'status'}
              size="small"
            />
          </Box>
        ))}
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, ...sx }}>
      {items.map((item, index) => (
        <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="body2" color="text.secondary">
            {item.label}:
          </Typography>
          <StatusChip
            label={item.value}
            variant={item.chipVariant || 'status'}
            size={item.chipSize || 'medium'}
          />
        </Box>
      ))}
    </Box>
  );
};
